import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = ({ isOpen, onItemClick, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // track current active section from URL
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const parts = location.pathname.split("/");
    const idx = parts.findIndex(p => p === "admin");
    if (idx !== -1 && parts[idx+1]) {
      setActiveSection(parts[idx+1]);
    }
  }, [location]);

  const partitions = [
    {
      title: "Company",
      items: [
        { id: "add-company", name: "Add Company" },
        { id: "add-company-by-email", name: "Add company via email" },
        { id: "view-company", name: "Edit companies" },
        // { id: "subscription-status", name: "Subscription status" },
        // { id: "manual-subscription", name: "Manually add subscription" },
      ],
    },
    {
      title: "Department",
      items: [
        { id: "view-department", name: "View/Assign departments" },
        { id: "manage-department", name: "Manage/Edit departments" },
        { id: "add-assessment-type", name: "Add new department" },
      ],
    },
    {
      title: "Assessment",
      items: [
        { id: "assessment-dashboard", name: "Dashboard" },
        { id: "all-assessments", name: "Search user" },
        { id: "review-company", name: "Review by company" },
        { id: "review-department", name: "Review by department" },
        { id: "assessment-status", name: "Assessment completion status" },
      ],
    },
  ];

  const handleSectionClick = id => {
    setActiveSection(id);
    navigate(`/admin/${id}`);
    onItemClick();
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`}>
    {isOpen &&  <button className="sidebar-close" onClick={onClose} aria-label="Close sidebar">
        ×
      </button>}
      {partitions.map(part => (
        <div key={part.title} className="sidebar-partition">
          <div className="sidebar-partition-title">{part.title}</div>
          <ul>
            {part.items.map(sec => (
              <li
                key={sec.id}
                className={activeSection === sec.id ? "active" : ""}
                onClick={() => handleSectionClick(sec.id)}
              >
                {sec.name}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
